import { io } from 'socket.io-client';
import store from '../store';

class SocketChat {
  socket;

  setupSocketConnection(accessToken) {
    // process.env.VUE_APP_SOCKET_IO
    const socketUrl = 'http://localhost:3005'; // https://vovat.mediatech.vn:3015
    // console.log('SocketChat --> accessToken', accessToken);
    this.socket = io(socketUrl, {
      // transports: ['websocket'],
      // path: '/socketio/',
      auth: {
        token: accessToken,
      },
    });

    // this.socket.on('connect', () => {
    //   this.socket
    //     .emit('authenticate', { token: accessToken }) // send the jwt
    //     .on('authenticated', () => {
    //       // do other things
    //     })
    //     .on('unauthorized', (msg) => {
    //       console.log(`unauthorized: ${JSON.stringify(msg.data)}`);
    //       throw new Error(msg.data.type);
    //     });
    // });
    // this.socket.on('connect', () => {
    //   console.log('Connected to server');
    //   const message = 'Helo from client';

    //   // store.commit('socketio/SOCKET_CONNECT');
    //   // store.commit('socketio/SOCKET_MESSAGECHANNEL', message);

    //   // this.socket.emit('receive-message', message);
    // });
    // this.socket.on('broadcast-message', (message) => {
    //   console.log('broadcast-message listen message', message);
    //   this.message = message
    // });
    // this.socket.on('disconnect', () => {
    //   console.log('Disconnected from server');
    //   store.commit('socketio/SOCKET_DISCONNECT');
    // });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      store.commit('socketio/SOCKET_DISCONNECT');
    }
  }
}

export default new SocketChat();
